/* ------------------------------------*\
    VARIABLE DECLARATION
\*------------------------------------*/
// var all_variations;
// var all_variations_sorted = [];
// var b6_variations = [];
// var b4_variations = [];
// var $variation_form;

/*------------------------------------*\
Variable Product methods
\*------------------------------------*/

function setupVariableProduct(){
    const $select2_object = $('#size');
    var     $variation_form = $('form.variations_form');
    console.log($variation_form);


    if(!$select2_object.hasClass('.select2-hidden-accessible')){
        $select2_object.select2({
            placeholder:'SIZE',
            debug: true,
            minimumResultsForSearch: -1, //remove search

        });
        $select2_object.on("select2:select", function (e) {
            console.log(e.params.data.id);
            $variation_form
                .find('input[name=variation_id]')
                .val( e.params.data.id )
                .trigger('change');
            $variation_form
                .find('#a_variation_id')
                .attr('href', '/cart/?add-to-cart='+e.params.data.id );

        });
    }
}
